// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/view/org/Org.css
// module id = 2012
// module chunks = 0